import(/* webpackMode: "eager" */ "/codebuild/output/src1942162425/src/faculdademetropolitana/src/app/layout.tsx");
